import type { HighlightView } from "../../model/Highlight";

// Враги в моменте — для заглушки превью, пока клипа нет.
export const momentVictims = (highlight: HighlightView): number[] => {
  const { details } = highlight;
  switch (highlight.kinds[0]) {
    case "lane_double":
      return details.lane_victims;
    case "parries":
      return details.parry_victims;
    case "midboss":
      return [];
    case "ultimate":
      return details.ult_victims;
    default:
      return details.victims;
  }
};
